module.exports = __webpack_public_path__ + "static/media/blank-profile-picture-973460_640.9acfe78b.png";